module["exports"] = [
  "###-####"
];
